/**
 * Who may open the Application Designer.
 *
 * One answer for every page, and deliberately NOT a new permission. Patient
 * Summary's Design View already gated on administrator or `system.config`, with
 * a test pinning it to avoid introducing a second permission to manage; the
 * Application Designer inherits exactly that rule so adding a designable page
 * never adds an access-control decision.
 *
 * This gate controls the Design BUTTON and the draft editor only. It is not a
 * data permission: what an element is allowed to show is decided by the native
 * page on every render, through the host's access map.
 */
export const DESIGN_PERMISSION = "system.config";
export const DESIGN_ROLE = "administrator";

export function canDesignPages(user) {
  if (!user) return false;
  if ((user.roles || []).includes(DESIGN_ROLE)) return true;
  return (user.permissions || []).includes(DESIGN_PERMISSION);
}
